import React, { useEffect, useRef, useState } from "react";
import "./ChangePassword.scss";
import { AppIcons } from "../../data/appIcons";
import Image from "../../components/image/Image";
import FormCreator from "../../components/forms/FormCreator";
import { changePasswordFormConfig } from "./changePassword.formfields.config";
import Buttons from "../../components/ui/button/Buttons";
import { useChangeUserPasswordMutation } from "../../app/services/authAPI";
import SwalAlert from "../../services/swalService/SwalService";
import { logout } from "../../app/slice/authSlice";
import { removeCookie } from "../../utils/Cookies/CookieHandler";
import { useDispatch } from "react-redux";
import { getAuthProps } from "../../lib/authenticationLibrary";

const ChangePassword = () => {

  const userRef = useRef(null);
  const { error, success } = SwalAlert();
  const dispatch = useDispatch();
  const authDetails = getAuthProps();
  const { user } = authDetails;

  const [changePasswordForm, setChangePasswordForm] = useState(changePasswordFormConfig);

  const [changePassword, {
    isLoading: isChanging,
    isSuccess: isChanged,
    data: changedPasswordData
  }] = useChangeUserPasswordMutation();

  const resetForm = () => {
    const form = { ...changePasswordFormConfig };
    form.initialState = { ...changePasswordFormConfig.initialState };
    setChangePasswordForm(form);
  };

  const handleClick = () => {
    const formData = userRef.current.getFormData();
    if (formData) {
      const req = {
        userID: user.userID,
        emailAddress: formData.emailAddress,
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword,
      };
      changePassword(req);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    removeCookie('rememberMe');
  };

  useEffect(() => {
    if (user) {
      const userEmail = user?.emailAddress;
      const form = { ...changePasswordFormConfig };
      form.initialState = {
        ...changePasswordFormConfig.initialState,
        emailAddress: userEmail,
      };
      setChangePasswordForm(form);
    }
    else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isChanged && changedPasswordData) {
      if (changedPasswordData.errorMessage.includes('incorrect')) {
        error("", changedPasswordData.errorMessage);
      } else {
        success("Password has been changed!", "For security reasons, you will be logged out.Please log in again with your new password.")
          .then((confirmed) => {
            if (confirmed) {
              handleLogout();
            }
          })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChanged, changedPasswordData]);

  
  return (
    <div className="change-password">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="vector-sec">
            <Image
              imgCustomClassName="order-icon"
              imagePath={AppIcons.ChangePassword}
              altText="Arrow Icon"
            />
          </div>
        </div>
        <div className="col-xl-6 col-lg-6 col-12">
          <div className="form-sec">
            <div className="inner-form-part">
              <div className="row">
                <div className="col-12">
                  <div className="form-title">Change Password</div>
                </div>
              </div>
              <div className="row">
                <FormCreator ref={userRef} config={changePasswordForm} />
              </div>
              <div className="row mt-4">
                <div className="col-12 d-flex justify-content-center">
                  <Buttons
                    buttonText="Submit"
                    buttonTypeClassName="ml-3 btn blue-btn w-full"
                    onClick={handleClick}
                    isLoading={isChanging}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
